import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  autoresponderState: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: false,
  },
  postApiStatus: {
    statusCode: null,
    statusText: null,
    data: false,
  },
};

export const autoresponderSlice = createSlice({
  name: "autoresponder",
  initialState: INITIAL_STATE,
  reducers: {
    fetchAutoResponder: (state) => {
      state.autoresponderState.isLoading = true;
    },
    fetchAutoResponderSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      autoresponderState: {
        ...state.autoresponderState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchAutoResponderFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      autoresponderState: {
        ...state.autoresponderState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    updateAutoResponder: (state) => {
      state.autoresponderState.isLoading = true;
    },
    updateAutoResponderSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      autoresponderState: {
        ...state.autoresponderState,
        error: null,
        isLoading: false,
      },
      postApiStatus: {
        ...state.postApiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    updateAutoResponderFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      autoresponderState: {
        ...state.autoresponderState,
        error: action.payload?.message,
        isLoading: false,
      },
      postApiStatus: {
        ...state.postApiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearAutoResponder: (state) => ({
      ...state,
      autoresponderState: {
        ...state.autoresponderState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: false,
      },
    }),
  },
});

export const {
  fetchAutoResponder,
  fetchAutoResponderFailure,
  fetchAutoResponderSuccess,
  updateAutoResponder,
  updateAutoResponderFailure,
  updateAutoResponderSuccess,
  clearAutoResponder,
} = autoresponderSlice.actions;
export const autoresponderReducer = autoresponderSlice.reducer;
